import React from 'react';
import { Container, Table } from 'react-bootstrap';

const DefinitionEntitaeten_m = () => {
  return (
    <Container className="mt-4">
      <h2 className="section-title">Definition Entitäten</h2>
      <div className="section-title-underline"></div>

      {/* Text styled like on the other pages */}
      <div className="aktuelles-text" style={{ marginTop: "0.5rem" }}>
        <p>
          Im Bericht werden Definitionen der Entitäten über die einschlägigen ICD-10-Codes verwendet, 
          die die Arbeitsgruppe Berichtsformate der Plattform §65c festgelegt hat.
           Diese sind in der Tabelle zusammen mit weiteren ausgewählten Entitäten zu finden. 
           Auf diese Weise wird sichergestellt, dass die Berichte aller Landeskrebsregister gemeinsame Definitionen und Zuordnungen verwenden und die Statistiken vergleichbar sind.
           Zusätzlich gibt eine weitere Übersichtstabelle die in diesem Bericht verwendeten Histologiegruppen nach den ICD‑O‑3‑Morphologiecodes an. 
        </p>
      </div>
      <h5 className="mb-3">
        Definitionen der Entitäten gemäß dem Beschluss der Plattform §65c und einiger ausgewählter Entitäten
      </h5>

      <Table
  striped
  bordered
  hover
  responsive
  size="sm"
  className="definition-table"
>
        <thead>
          <tr>
            <th>Entität</th>
            <th>ICD-10</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Mundbereich</td><td>C00, C02-C06 ohne C00.0-C00.2</td></tr>
          <tr><td>Große Speicheldrüsen</td><td>C07 - C08</td></tr>
          <tr><td>Naso-, Oro- bis Hypopharynx</td><td>C01, C09 - C14 ohne C14.8</td></tr>
          <tr><td>Speiseröhre</td><td>C15</td></tr>
          <tr><td>Magen</td><td>C16</td></tr>
          <tr><td>Dünndarm</td><td>C17</td></tr>
          <tr><td>Kolon</td><td>C18</td></tr>
          <tr><td>Rektum</td><td>C19, C20</td></tr>
          <tr><td>Anus</td><td>C21</td></tr>
          <tr><td>Leber</td><td>C22</td></tr>
          <tr><td>Gallenblase und Gallenwege</td><td>C23, C24</td></tr>
          <tr><td>Bauchspeicheldrüse</td><td>C25</td></tr>
          <tr><td>Sonstige/n.n.b. Verdauungsorgane</td><td>C26</td></tr>
          <tr><td>Nase/Nebenhöhlen/Mittelohr</td><td>C30, C31</td></tr>
          <tr><td>Kehlkopf</td><td>C32</td></tr>
          <tr><td>Trachea</td><td>C33</td></tr>
          <tr><td>Lunge</td><td>C34</td></tr>
          <tr><td>Mediastinum/Brustorgane</td><td>C37-C39</td></tr>
          <tr><td>Knochen und Knorpel</td><td>C40, C41</td></tr>
          <tr><td>Malignes Melanom der Haut</td><td>C43</td></tr>
          <tr><td>Nicht-melanotischer Hautkrebs</td><td>C44</td></tr>
          <tr><td>Mesotheliom</td><td>C45</td></tr>
          <tr><td>Weichteilgewebe ohne Mesotheliom</td><td>C46-C49</td></tr>
          <tr><td>Brustdrüse</td><td>C50</td></tr>
          <tr><td>Vulva</td><td>C51</td></tr>
          <tr><td>Gebärmutterhals</td><td>C53</td></tr>
          <tr><td>Gebärmutterkörper</td><td>C54, C55</td></tr>
          <tr><td>Eierstöcke</td><td>C56</td></tr>
          <tr><td>Sonstige weibl. Geschlechtsorgane</td><td>C52, C57, C58</td></tr>
          <tr><td>Penis</td><td>C60</td></tr>
          <tr><td>Prostata</td><td>C61</td></tr>
          <tr><td>Hoden</td><td>C62</td></tr>
          <tr><td>Sonstige männl. Geschlechtsorgane</td><td>C63</td></tr>
          <tr><td>Niere</td><td>C64</td></tr>
          <tr>
            <td>Harnwege/Harnorgane n.n.b.</td>
            <td>C65, C66, C68<br/>(D41.1 → C65, D41.2 → C66, D41.3/7/9 → C68)*</td>
          </tr>
          <tr><td>Harnblase</td><td>C67 (D41.4, D09.0)*</td></tr>
          <tr><td>Auge</td><td>C69</td></tr>
          <tr><td>Meningen</td><td>C70</td></tr>
          <tr><td>Gehirn</td><td>C71</td></tr>
          <tr><td>Rückenmark/Hirnnerven</td><td>C72</td></tr>
          <tr><td>Schilddrüse</td><td>C73</td></tr>
          <tr><td>Nebennieren/andere endokrine Drüsen</td><td>C74, C75</td></tr>
          <tr><td>Ungenaue/n.n.b. Lokalisation</td><td>C76, C80</td></tr>
          <tr><td><strong>Hämatoonkologische Erkrankungen</strong></td><td></td></tr>
          <tr><td>Morbus Hodgkin</td><td>C81</td></tr>
          <tr><td>Follikuläres Lymphom</td><td>C82</td></tr>
          <tr><td>Kleinzelliges B-Zell-Lymphom</td><td>C83.0</td></tr>
          <tr><td>DLBCL (diffus großzelliges B-Zell)</td><td>C83.3</td></tr>
          <tr><td>Non-Hodgkin-Lymphom, n.n.b.</td><td>C85.9</td></tr>
          <tr><td>Multiples Myelom</td><td>C90</td></tr>
          <tr><td>Chronische lymphatische Leukämie</td><td>C91.1</td></tr>
          <tr><td>Akute lymphatische Leukämie</td><td>C91.0, C91.8</td></tr>
          <tr><td>Chronische myeloische Leukämie</td><td>C92.1, C94.8</td></tr>
          <tr><td>Akute myeloische Leukämie</td><td>C92.0, C92.3-.6, C92.8, C93.0, C94.0/2/3/4</td></tr>
          <tr><td>Myelodysplastische/myeloproliferative Neoplasien</td><td>C92.2, C93.1, C93.3</td></tr>
          <tr><td><strong>Carcinoma in situ</strong></td><td></td></tr>
          <tr><td>CIS des Kolons</td><td>D01.0*</td></tr>
          <tr><td>Melanoma in situ</td><td>D03*</td></tr>
          <tr><td>CIS der Brustdrüse</td><td>D05*</td></tr>
          <tr><td>CIS der Cervix uteri</td><td>D06*</td></tr>
          <tr><td><strong>Gutartige Neubildungen & unklare</strong></td><td></td></tr>
          <tr><td>Meningen/Gehirn/ZNS (gutartig)</td><td>D32, D33*</td></tr>
          <tr><td>Polycythaemia vera</td><td>D45</td></tr>
          <tr><td>Myelodysplastische Syndrome</td><td>D46</td></tr>
          <tr><td>Essentielle Thrombozythämie</td><td>D47.3</td></tr>
        </tbody>
      </Table>

      {/* Neue Histologie-Tabelle */}
      <h5 className="mt-4 mb-2">
        Übersicht über Histologiegruppen (ICD-O-3 Morphologie):
      </h5>

      <Table
  striped
  bordered
  hover
  responsive
  size="sm"
  className="definition-table"
>
        <thead>
          <tr>
            <th>Histologiegruppe</th>
            <th>ICD-O-3 Morphologie</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Neoplasien, ohne nähere Angabe</td>
            <td>8000-8005</td>
          </tr>
          <tr>
            <td>Unspezifische epitheliale Neoplasien</td>
            <td>8010-8012, 8020-8022, 8050, 8244</td>
          </tr>
          <tr>
            <td>Neuroendokrine Tumoren</td>
            <td>8013, 8042-8045, 8150-8153, 8155-8158, 8240-8243, 8245, 8247-8249, 8680-8700</td>
          </tr>
          <tr>
            <td>Kleinzelliges Karzinom, ohne nähere Angabe</td>
            <td>8041</td>
          </tr>
          <tr>
            <td>Nichtkleinzelliges Karzinom</td>
            <td>8046</td>
          </tr>
          <tr>
            <td>Platten- und Übergangsepithelkarzinome</td>
            <td>8051-8081, 8083-8086, 8120-8131</td>
          </tr>
          <tr>
            <td>Adenokarzinome</td>
            <td>8140-8149, 8160-8163, 8190-8231, 8250-8384, 8440-8551, 8570-8574, 8940-8941, 9014-9015, 9110</td>
          </tr>
          <tr>
            <td>Hepatozelluläre Karzinome</td>
            <td>8170-8175</td>
          </tr>
          <tr>
            <td>Adenosquamöses Karzinom</td>
            <td>8560</td>
          </tr>
          <tr>
            <td>Metaplastisches Karzinom, ohne nähere Angabe</td>
            <td>8575</td>
          </tr>
          <tr>
            <td>Melanom</td>
            <td>8720-8790</td>
          </tr>
          <tr>
            <td>Sarkome</td>
            <td>
              8800-8803, 8710-8713, 8804-8806, 8810-8932, 8934-8936, 8959-8975, 8990-8991, 9020-9044,
              9120-9133, 9150, 9161, 9170, 9180-9195, 9210-9243, 9250-9252, 9260-9261, 9270-9342,
              9364-9373, 9480, 9540-9581
            </td>
          </tr>
          <tr>
            <td>Karzinosarkom, ohne nähere Angabe</td>
            <td>8980</td>
          </tr>
          <tr>
            <td>B-Zell-Neoplasien</td>
            <td>
              9597, 9670-9673, 9678-9699, 9712, 9728, 9731-9738, 9760-9764, 9811-9818,
              9823, 9826, 9833, 9836, 9940
            </td>
          </tr>
        </tbody>
      </Table>

      {/* Fußnoten zu den Asterisken */}
      <p
        style={{
          fontSize: "0.9rem",
          fontStyle: "italic",
          marginTop: "0.5rem",
        }}
      >
        n.n.b: nicht näher bezeichnet; CIS: Carcinoma in situ
      </p>
      <p
        style={{
          fontSize: "0.9rem",
          fontStyle: "italic",
          marginTop: "0.1rem",
        }}
      >
        * Die D-Codes werden gesondert ausgewiesen.
      </p>
    </Container>
  );
};

export default DefinitionEntitaeten_m;
